const CountryFilterData = [
    'Africa',
    'Americas',
    'Asia',
    'Europe',
    'Oceania',
]

export default CountryFilterData;